export const SELECTED_PLAN_KEY = "easyroomSelectedPlan"

export const storeSelectedPlan = (planId: string): void => {
    sessionStorage.setItem(SELECTED_PLAN_KEY, planId)
}

export const readSelectedPlan = (): string | null => sessionStorage.getItem(SELECTED_PLAN_KEY)

export const clearSelectedPlan = (): void => {
    sessionStorage.removeItem(SELECTED_PLAN_KEY)
}
